import * as actions from '../actions';
import { TATTOOIST_FORM, TATTOO_OPERATOR_FORM } from '../../constants';

const initialState = {
  [TATTOOIST_FORM]: false,
  [TATTOO_OPERATOR_FORM]: true
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.CAPTCHA_VALID:
      return {
        ...state,
        ...action.payload
      };
    case actions.CLEAR_FORM:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
